import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>AMXL Prf Picking Picked</h2>
  <h3>Description</h3>
  <p>This exception is raised when a shipment item is close to its CPT while in a Rodeo work pool state of 'Picking Picked' thus at risk of becoming rolled freight</p>
  <h3>SOP</h3>
  <ul>
    <li>Check if unit is on dock. Check all drop zones and POPS area
      <ul>
        <li>Yes, SLAM and load unit immediately</li>
        <li>No, move to step #2</li>
      </ul>
    </li>
    <li>Check if unit remained in bin from which it was virtually picked
      <ul>
        <li>Yes, coach picker for scanned not picked error. Move to step #6</li>
        <li>No, move to step #3</li>
      </ul>
    </li>
    <li>If unable to locate physical unit, check in tote through POPS missing tote workflow</li>
    <li>Process through send runner process</li>
    <li>Pack from POPS shipment</li>
    <li>SLAM unit and immediately load on appropriate pallet/trailer</li>
  </ul>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PICKING_PICKED.jsx